type User = {
  userId?: string
  userName?: string
  userEmail?: string
}

type CustomEventMeta = {
  [k: string]: string
}

type InitConfig = {
  tenantCode: string
  equityType: string
  productCode?: string
}


export function getTrackerInstance() {
  try {
    // 每次都更新一下url
    if (window?.ineum) {
      window?.ineum('meta', 'url', window.location.href)
    }
  }
  catch (e) { }
  return (window as any).ineum
}

export function initTracker(config: InitConfig) {
  const tracker = getTrackerInstance()
  if (!tracker) return
    ; (Object.keys(config) as Array<keyof InitConfig>).forEach((key) => {
      tracker('meta', key, config[key])
    })
}

export function trackMetaData(key: string, value: string) {
  const tracker = getTrackerInstance()
  if (!tracker) return
  tracker('meta', key, value)
}

export function trackUser(user: User) {
  const tracker = getTrackerInstance()
  if (!tracker) return
  const { userId, userName } = user
  tracker('user', userId, userName)
}

export function trackError(error: Error | string, options?: { meta?: CustomEventMeta, componentStack?: string }) {
  const tracker = getTrackerInstance()
  if (!tracker) return
  tracker('reportError', error, options)
}

export function trackEvent(eventName: string, params?: { meta?: CustomEventMeta, duration?: number }) {
  const tracker = getTrackerInstance()
  if (!tracker) return
  tracker('reportEvent', eventName, params)
}

// 上报错误事件，包含错误信息和事件参数
export function trackErrorboundary(err: Error, eventFunName: string, eventName: string, params?: { meta?: CustomEventMeta, duration?: number }) {
  if (!err) return
  try {
    trackEvent('TRACK_ERROR_COLLECTION', {
      meta: {
        trackFuncName: eventFunName,
        trackEventName: eventName,
        trackParams: JSON.stringify(typeof params === 'object' ? params : {}),
        errorMsg: err?.message,
        errorType: err?.name,
        errorStack: err?.stack,
      },
    })
  }
  catch (e) {
    trackEvent('TRACK_ERROR_COLLECTION', {
      meta: {
        trackFuncName: 'TRACK_ERROR_COLLECTION',
        trackEventName: `${eventFunName}_${eventName}`,
        trackParams: JSON.stringify(params),
        errorMsg: e?.message,
        errorType: e?.name,
        errorStack: e?.stack,
      },
    })
  }
}
